import { Resetter } from 'recoil';

export function useClearStorage() {
  const atomsToReset: Resetter[] = [
    // TODO: add atoms to reset.
  ];

  const clearStorage = () => {
    atomsToReset.forEach((resetAtom) => resetAtom());
    localStorage.clear();
  };

  return clearStorage;
}
